import { get } from 'lodash'
import { required } from 'utils/validation'
import { AWARD_FILE_CATEGORY_TYPES } from '../../constants/enums'

export default function(values = {}) {

  return {
    title: required(values.title),
    category: {
      value: required(get(values, 'category.value'))
    },
    section: {
      value: get(values, 'category.value') === AWARD_FILE_CATEGORY_TYPES.activity.id && required(get(values, 'section.value'))
    }
  }
}
